import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AppContainer from './Container';
import Loading from '~/components/Loading';
import { PrefetchData, prefetchData } from '~/common/services';
import { descWithI18n, titleWithI18n } from '~/common/consts';
import pageConfig from '~/config';
import { Tea } from '~/common/sendLogV3/export';

const shareImageMap: Record<string, string[]> = {
  en: [
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_51/EN1_s1956957.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_48/EN2_s2172285.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_46/EN3_s1145656.jpg'
  ],
  ja: [
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_49/JA1_s1911921.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_48/JA2_s2087135.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_44/JA3_s1115948.jpg'
  ],
  ko: [
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_39/KR1_s1914899.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_37/KR2_s2115278.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_44/KR3_s1104856.jpg'
  ],
  'zh-Hant': [
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_49/ZH1_s1946451.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_42/ZH2_s2150117.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_40/ZH3_s1133586.jpg'
  ],
  de: [
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_54/DE1_s1917666.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_50/DE2_s2090091.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_51/DE3_s1123086.jpg'
  ],
  es: [
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_44/ES1_s1914475.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_46/ES2_s2098030.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_44/ES3_s1117609.jpg'
  ],
  fr: [
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_02_04/FR_s1892486.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_02_00/FR2_s2063134.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_54/FR3_s1106710.jpg'
  ],
  id: [
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_02_09/ID_s1894137.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_02_01/ID2_s2061463.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_52/ID3_s1118010.jpg'
  ],
  pt: [
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_02_10/PT_s1905468.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_02_05/PT2_s2075685.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_02_01/PT3_s1112505.jpg'
  ],
  th: [
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_02_13/TH_s1928819.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_57/TH2_s2109038.jpg',
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_12_25_09_01_56/TH3_s1122214.jpg'
  ]
};

const start = Date.now();
export default function App(props: any) {
  const { data } = props._ssrData;

  const { language, isInit, code, index } = (data?.prefetchData as PrefetchData) || {};

  const renderTDK = () => {
    return {
      title: (titleWithI18n[language] || titleWithI18n.en).replace('{{ReferralCode}}', code),
      description: descWithI18n[language] || descWithI18n.en
    };
  };

  const posterList = shareImageMap[language] || shareImageMap.en;
  const posterImage = posterList[index] || posterList[0];

  useEffect(() => {
    if (!isInit) {
      return;
    }
    location.href = posterImage;
  }, [isInit, posterImage]);
  useEffect(() => {
    Tea.initSendLogV3({
      app_id: pageConfig.appId,
      activity_id: pageConfig.actId,
      zone: pageConfig.region,
      // 非必传参数，这个字段可以自定义通用参数，并且会在所有埋点事件里统一传参
      default_data: {
        page_text: pageConfig.title,
        activity_form: '1'
      }
    });

    Tea.sendLogV3('acv_pageview', {
      index: 1
    });
    Tea.sendLogV3('acv_pageload', {
      index: 1,
      duration: Date.now() - start
    });
  }, []);
  return (
    <>
      <Helmet>
        <meta property="og:title" content={renderTDK().title} />
        <meta property="og:description" content={renderTDK().description} />
        <meta property="og:image" content={posterImage} />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="600" />
        <meta name="twitter:title" content={renderTDK().title} />
        <meta name="twitter:description" content={renderTDK().description} />
        <meta name="twitter:image" content={posterImage} />
        <title>{renderTDK().title}</title>
      </Helmet>
      <AppContainer {...props} />
    </>
  );
}

// 支持 react-helmet
App.disableStream = true;

App.init = (context) => {
  const { level } = context.request.query;
  if (['0', '1', '2'].includes(level)) {
    // 2 表示服务器渲染，1表示服务端预取数据，0表示客户端渲染
    context.targetRenderLevel = Number(level);
  }
  // 2 表示服务器渲染，1表示服务端预取数据，0表示客户端渲染
};

App.prefetch = prefetchData;

App.config = {
  features: {
    ssr: {
      customPrefetch: {
        LoadingComponent: Loading
      }
    }
  }
};
